export enum Theme {
  TD = 'td',
  CJX = 'cjx'
}
